/* @flow */

import * as braindateTypes from 'src/shared/domain/braindate/action/braindateActionTypes';
import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';

const initialState = {};

const _patchEntities = (state: Object, action: Object) =>
  patchEntities(state, action, 'braindates');

const _deleteBraindate = (state: Object, action: Object) => {
  const { id } = action;

  const newState = { ...state };

  delete newState[id];

  return newState;
};

export default createReducer(initialState, {
  [entititesTypes.PATCH_ENTITIES]: _patchEntities,
  [braindateTypes.DELETE_BRAINDATE_LOCALLY]: _deleteBraindate,
});
